var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-profile"},[_c('a',{staticClass:"username username-custom",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.username))])])}
var staticRenderFns = []

export { render, staticRenderFns }